<div class="tw-py-[0.3125rem]">
  <div class="tw-my-2.5">
    <div class="tw-overflow-x-auto">
      <table class="tw-w-full tw-text-sm">
        <thead class="tw-bg-success tw-text-success-content">
          <tr class="tw-border tw-border-success">
            <th class="tw-border-r tw-border-current tw-p-1">Hành khách</th>
            <th class="tw-w-[40%] tw-border-r tw-border-current tw-p-1">
              Họ tên
            </th>
            <th class="tw-border-r tw-border-current tw-p-1">Ngày sinh</th>
          </tr>
        </thead>
        <tbody>
          @for (item of passengers(); track item.index) {
            <tr class="tw-border-b tw-border-success hover:tw-bg-base-100">
              <td class="tw-border-l tw-border-success tw-p-1 last:tw-border-r">
                {{ item.type | passengerType }}
              </td>
              <td class="tw-border-l tw-border-success tw-p-1 last:tw-border-r">
                {{ item.fullName }}
              </td>
              <td class="tw-border-l tw-border-success tw-p-1 last:tw-border-r">
                {{ item.birthday }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
